// extracted by mini-css-extract-plugin
module.exports = {"selectBodySearchList":"select-body-search-list-9a9"};